const LandingPageTempalte = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-id="treeNode_landingpagetemplates_19AssetIcon"
    className="spectrum-Icon_368b34 spectrum-Icon--sizeS_368b34 TreeIconWrapper spectrum-Icon_e2d99e"
    focusable="false"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    fill={'rgb(105, 123, 144)'}
  >
    <defs>
      <symbol id="icon-meue-landing-page-template" viewBox="0 0 20 20">
        <path
          d="M0 1.875v16.25a.625.625 0 00.625.625h18.75a.625.625 0 00.625-.625V1.875a.625.625 0 00-.625-.625H.625A.625.625 0 000 1.875zM18.75 17.5H1.25V5h17.5z"
          data-name="Landing Page Template"
        ></path>
      </symbol>
    </defs>
    <use xlinkHref="#icon-meue-landing-page-template" fill="#697B90"></use>
  </svg>
);

export default LandingPageTempalte;
